import React, { useEffect, useMemo, useRef, useState } from "react";
import { CircularProgress } from "@mui/material";
import { usePermission } from "../../context/PermissionContext";
import { capitalizeFirstLetter, getSaleTrack } from "./invoiceUtils";
import DateConverter from "@heartinz/date_and_time_processor";
import Messages from "../../constants/Messages";
import QRCode from "qrcode";
import axios from "axios";
import { useShowAlert } from "../../context/AlertContext";
import { useNavigate } from "react-router-dom";
import AxiosInstance from "../../utils/AxiosInstance";
import { getOS } from "../../utils/getOs";
import { useNetwork } from "../../context/NetworkContext";
import handleError from "../../constants/handleError";
import { useSaleContext } from "../../context/SaleContext";
import { FormatedTemplateData } from "../templateDataHandler";
import InvoiceToggleActionCard from "./InvoiceToggleActionCard";
import InvoiceInfoSidebar from "./InvoiceInfoSidebar";
import Convertinvoice from "../../components/pages/sale/ConvertInvoice";
import PaySettleModal from "./PaySettleModal ";
import uRLs from "../../utils/baseUtils";
import { useAuth } from "../../context/AuthProvider";
import { templateMap } from "../templateMap";
import { getInvoiceConfig } from "./getInvoiceConfig";
import jsPDF from "jspdf";
import InterRegular from "../../components/pages/estimation/font/Inter_24pt-Regular-normal";
import InterBold from "../../components/pages/estimation/font/Inter_24pt-Bold-normal";
import NotoSansMonoBold from "../../components/pages/sale/font/NotoSansMono-Bold-bold";
import NotoSansMonoReular from "../../components/pages/sale/font/NotoSansMono-Regular-normal";
import ReturnSaleInvoice from "../a4/ReturnSaleInvoice";
import { useContextApi } from "../../context/ContextApi";
import PurchaseView from "../../components/pages/purchase/PurchaseView";
import { DownloadIcon, EditIcon, PrinterIcon, ReceiptIcon, ShareIcon, ShowIcon, UndoIcon, WhatsappIcon, XIcon } from "../../constants/Icons";

function TemplateModalLayout({
  isOpen,
  isData,
  onClose,
  selectedOption,
  setSelectedOption,
  setSaleData,
  isActive,
  displayCreatedTime,
  isPurchase, 
  // isReturnViews =false,
}) {
  const {
    permission,
    blockedPermissions,
    viewOption,
    hasModulePermission,
    storeSettings,
  } = usePermission();
 
  const { setPaymentModal, setSaleModalOpen,optData, setOptData} = useSaleContext();
  const [data, setData] = useState({});
  const globalData = FormatedTemplateData(data, storeSettings);
  const [edit, setEdit] = useState(false);
  const [qrCodeDataUrl, setQrCodeDataUrl] = useState("");
  const terms = storeSettings?.invoiceSettings?.termsAndConditions;
  const [selectedSale, setSelectedSale] = useState(null);

  const { useEscapeKey } = useContextApi();

  const onDataUpdate = async () => {
    const updatedData = await handleSaleItems(data?._id);

    if (updatedData) {
      setData(updatedData);
      setSaleData?.(updatedData);
    }
  };

  const onDataChange = true;
  const os = getOS();
  const [download, setDownload] = useState(false);
  const [shareLoad, setShareLoad] = useState(false);
  const [billing, setBilling] = useState(false);
  const [selectTermalOption, setSelectTermalOption] = useState("TMLBAS");
  const [selectHALFA4Option, setSelectHALFA4Option] = useState("HA4RET");
  const [closeAuto, setCloseAuto] = useState(true);
  const [saleLoading, setSaleLoading] = useState(false);
  const [isBtnLoading, setBtnLoading] = useState(false);
  const [isPaySettleModalOpen, setIsPaySettleModalOpen] = useState(false);
  const [isMainModalOpen, setIsMainModalOpen] = useState(true);
  const [showConfirm, setShowConfirm] = useState(false);
  const [returnData, setIsReturnData] = useState("");
  const [isReturnView, setIsReturnView] = useState(false);
  const [share, setShare] = useState(false);
  const [print, setPrint] = useState(false);
  const showAlert = useShowAlert();
  const printLock = useRef(false);
const selectedTheme = {
  ...storeSettings?.invoiceSettings?.template,
  templateTheme: {
    primaryColor: "#f4f4f6",
    secondaryColor: "#ffffff",
    foregroundColor: "#242c6d",
    backgroundColor: "#f4f4f6",
    borderColor: "#c9c9d1",
    ...storeSettings?.invoiceSettings?.template?.templateTheme,
  },
};

  const [selectedSize, setSelectedSize] = useState(
    storeSettings?.printerSettings?.paperSize ||"A4",
  );

  const latestVersion = useMemo(() => {
    return isData?.saleVersion;
  }, [isData]);

  useEscapeKey(onClose);

  const { isUser, updateSettings, settings } = useAuth();
  const navigate = useNavigate();
  const { checkNetwork } = useNetwork();  
   const isReturnHistory = Boolean(returnData?.returnSaleData?.returnTrack ||isData?.returnSaleData?.returnTrack);

  const invoiceConfig = getInvoiceConfig(
    globalData,
    storeSettings,
    optData,
    settings,
  );

  const {
    isPreSale,
    isBillReceipt,
    timezone,    
    isBill,    
    documentConfig,
    showTaxDetails,
  } = invoiceConfig;

const getTemplateInvoiceConfig = (config) => {
  const templateDocumentConfig = {
    ...config?.documentConfig,
  };

  if (!optData?.isCustomerDisplay) {
    delete templateDocumentConfig.toData;
    delete templateDocumentConfig.toLabel;
  }

  if (!optData?.isSupplier) {
    delete templateDocumentConfig.supplierInfo;
  }

  if (!optData?.isRemark) {
    delete templateDocumentConfig.remarks;
  }

  if (!optData?.isPayment || config?.isPreSale) {
    delete templateDocumentConfig.cashPaid;
    delete templateDocumentConfig.cardPaid;
    delete templateDocumentConfig.onlinePaid;
    delete templateDocumentConfig.upiPaid;
    delete config.hasPayment;
  }

  if (!optData?.isBankDetails || config?.isPreSale) {
    delete templateDocumentConfig.bankDetails;
    delete templateDocumentConfig.upiId;
    delete templateDocumentConfig.upiQrLink;
  }

  return {
    ...config,
    documentConfig: templateDocumentConfig,
  };
};
const templateInvoiceConfig = getTemplateInvoiceConfig(invoiceConfig);
  const createdAt = data?.preSaleData?.createdAt || data?.createdAt || data?.returnSaleData?.createdAt;
  const createdTime =
    displayCreatedTime ||
    (createdAt
      ? DateConverter.ISOToDisplayFormat(
          DateConverter.convertToTimeZone(createdAt, timezone),
        )
      : "--:--");
  const isReturn = !!isReturnHistory || isPreSale || isPurchase;

  const handleSaleItems = async (saleId) => {  
    if (saleId === undefined) return;
    try {
      if (!checkNetwork()) return;
      const response = await AxiosInstance.get(
        `module/${isPreSale ? "presale/view" : "sale"}/${saleId}`,
      );
      return response.data.results;
    } catch (error) {
      handleError(error, showAlert);
      return null;
    }
  };

  const handleClose = () => {
    setIsMainModalOpen(false);
    setIsReturnView(false);
    setIsReturnView(false);
    setIsReturnData(null);
      const templateId =
    storeSettings?.invoiceSettings?.template?.templateId;
 if (templateId) {
        const a4 = templateId.match(/^([A-Z0-9]{6})/)?.[1];
        const thermal = templateId.match(/(TML[A-Z0-9]+)/)?.[1];
        const half = templateId.match(/(HA4[A-Z0-9]+)/)?.[1];

        if (a4) setSelectedOption(a4);
        if (thermal) setSelectTermalOption(thermal);
        if (half) setSelectHALFA4Option(half);
      }
    onClose();
  };

  const handleEdit = async (item) => {  
    const updatePermission = isPurchase ? "PURCHASE:update" : isPreSale ? "PRESALE:update" : "SALE:update";
    if (blockedPermissions(updatePermission) || permission === undefined) {
      setEdit(true);
      onClose?.();
      setSaleModalOpen(false);
      setPaymentModal(false);
      try {
        if (isPurchase) {
        navigate("/purchase", {
          state: {
            purchaseData: item,
            isEdit: true,
            navigatelist: "/listpurchase",
          },
        });
        return;
      }

        const data = await handleSaleItems(
          isPreSale ? item?.preSaleData?._id : item._id,
        );
        if (data) {
          if (isPreSale) {
              navigate("/editproforma", {
              state: data.preSaleData,
              mode: data.preSaleData.preSaleMode,
            });
          } else if (data.consumeVersion === "CONSUMEV2") {
            navigate("/editsale", { state: data });
          } else {
            navigate("/editsaleold", { state: data });
          }
        }
      } catch (error) {
        console.error("Error loading sale data:", error);
      } finally {
        setEdit(false);
      }
    } else {
      showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
    }
  };

  useEffect(() => {
    setData(isData);
    if(isData?.returnSaleData?.returnTrack){
      setSelectHALFA4Option("RETURN");
      setSelectedOption("RETURN");
    }
  }, [isData]);

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") {
        onClose();
      }
    };
    window.addEventListener("keydown", handleEsc);
    // Cleanup on unmount
    return () => {
      window.removeEventListener("keydown", handleEsc);
    };
  }, [onClose]);

  useEffect(() => {
    let isMounted = true;
    const paymentSettings = storeSettings?.paymentSettings;  
    if (!paymentSettings || !optData?.isBankDetails || isPreSale) {
      setQrCodeDataUrl("");
      return;
    }
    let targetUpiUrl = "";

    if (
      paymentSettings.upiQrLink &&
      paymentSettings.upiQrLink.startsWith("data:image")
    ) {
      setQrCodeDataUrl(paymentSettings.upiQrLink);
      return;
    } else if (paymentSettings.upiQrLink) {
      targetUpiUrl = paymentSettings.upiQrLink;
    } else if (paymentSettings.upiId) {
      const upi = paymentSettings.upiId;
      const name = paymentSettings.bankDetails?.beneficiaryName || "";
      targetUpiUrl = `upi://pay?pa=${encodeURIComponent(upi)}&pn=${encodeURIComponent(name)}&cu=INR`;
    }

    if (!targetUpiUrl) {
      setQrCodeDataUrl("");
      return;
    }

    // 2. Convert the UPI link into a base64 image Data URL for <img src="..." />
    QRCode.toDataURL(targetUpiUrl, { width: 300, margin: 2 })
      .then((url) => {
        if (isMounted) {
          setQrCodeDataUrl(url); // Now url is "data:image/png;base64,..."
        }
      })
      .catch((err) => {
        if (isMounted) {
          setQrCodeDataUrl("");
        }
      });

    return () => {
      isMounted = false;
    };
  }, [storeSettings?.paymentSettings,  optData?.isBankDetails,
  isPreSale,]);

  const handlePrintService = async (pdfBase64, printerName) => {
    try {
      const response = await axios.post(
        "http://127.0.0.1:9164/print/pdf",
        {
          pdfBase64,
          printerName,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      return true;
    } catch (error) {
      handleError(error, showAlert);
      return false;
    }
  };

  const handlePrintSystem = async (pdfBase64, printerName) => {
    if (
      os === "Windows" &&
      storeSettings?.printSystemSettings?.printThrough &&
      printerName
    ) {
      return await handlePrintService(pdfBase64, printerName);
    } else {
      setBilling(false);
    }
    return false;
  };

  const handlePrint = async () => {
    if (print) return;

    setPrint(true);
    try {
      let generator;
       if (isPurchase) {
      generator = templateMap.A4.PURCHASE?.print;
    } else {
      let generatorType;

      if (isPreSale) {
        generatorType = showTaxDetails ? "invoice" : "bill";
      } else {
        generatorType = isBill && !isBillReceipt ? "bill" : "invoice";
      }

      if (selectedSize === "A4") {
        const template = templateMap.A4[selectedOption];
        generator = template?.[generatorType] ?? template?.print;
      } else if (selectedSize === "HALFA4") {
        const template = templateMap.HALFA4[selectHALFA4Option];
        generator = template?.[generatorType] ?? template?.print;
      } else {
        const template = templateMap.TERMINAL[selectTermalOption];
        const printer = storeSettings?.printSystemSettings?.printThrough
          ? template.generator[selectedSize]
          : template.browser[selectedSize];

        generator = printer?.[generatorType];
      }   
    }   
      const printData = isReturnView ? returnGlobalData : globalData;

      const printInvoiceConfig = isReturnView
        ? returnTemplateInvoiceConfig
        : templateInvoiceConfig;
      const doc = await generator(
        printData,
        qrCodeDataUrl,
        terms,
        printInvoiceConfig,
        selectedTheme,        
        storeSettings,
      );
      const pdfBase64 = doc.output("datauristring").split(",")[1];
      const response = await handlePrintSystem(
        pdfBase64,
        storeSettings?.printSystemSettings?.printerName,
      );
      if (storeSettings?.printSystemSettings?.printThrough && response) {
        return;
      }

      const blob = doc.output("blob");
      const blobUrl = URL.createObjectURL(blob);

      const iframe = document.createElement("iframe");
      iframe.style.position = "fixed";
      iframe.style.right = "0";
      iframe.style.bottom = "0";
      iframe.style.width = "0";
      iframe.style.height = "0";
      iframe.style.border = "none";
      iframe.src = blobUrl;
      document.body.appendChild(iframe);
     iframe.onload = () => {
        const printWindow = iframe.contentWindow;

        const cleanup = () => {    
          if (iframe && iframe.parentNode) {
            iframe.parentNode.removeChild(iframe);
          }
          window.removeEventListener("afterprint", cleanup);
          printWindow.matchMedia("(print)").removeListener(handlePrintState);
        };

        const handlePrintState = (mql) => {       
          if (!mql.matches) {
            setTimeout(cleanup, 50); 
          }
        };
      
        printWindow.matchMedia("(print)").addListener(handlePrintState);      
        window.addEventListener("afterprint", cleanup);
        setPrint(false);
        setTimeout(() => {
          if (window.bootstrap && window.bootstrap.Dropdown) {
            const dropdownElementList = [].slice.call(
              document.querySelectorAll(".dropdown-toggle"),
            );
            dropdownElementList.map(function (dropdownToggleEl) {
              return new window.bootstrap.Dropdown(dropdownToggleEl);
            });
          }
        }, 100);     
        setTimeout(() => {
          printWindow.focus();
          printWindow.print();
        }, 300);
      };
    } catch (error) {
      setPrint(false);
          handleError(error, showAlert);
    } finally {
      setPrint(false);
    }
  };

  useEffect(() => {
    const handleEnterPrint = async (event) => {
      if (!isActive || !isMainModalOpen) return;
      const tag = event.target.tagName;
      const isTyping =
        tag === "INPUT" ||
        tag === "TEXTAREA" ||
        tag === "SELECT" ||
        event.target.isContentEditable;
      if (isTyping) return;

      if (event.key === "Enter" && !printLock.current) {
        event.preventDefault();

        printLock.current = true;

        handlePrint();
        // Allow next Enter after print closes
        setTimeout(() => {
          printLock.current = false;
          window.focus();
        }, 1000);
      }
    };

    window.addEventListener("keydown", handleEnterPrint);

    return () => {
      window.removeEventListener("keydown", handleEnterPrint);
    };
  }, [isMainModalOpen, globalData, isActive]);

  // useEffect(() => {
  //   if (storeSettings?.printerSettings?.paperSize) {
  //     setSelectedSize(storeSettings.printerSettings.paperSize);
  //   }
  // }, [storeSettings]);
  
  useEffect(() => {
  const printerSize = storeSettings?.printerSettings?.paperSize;

  if (!printerSize) {
    setSelectedSize("A4");
    return;
  }

  const availableSizes = isPurchase
    ? ["A4"]
    : isReturn || isPreSale
      ? ["HALFA4", "A4"]
      : ["2INCH", "3INCH", "4INCH", "HALFA4", "A4"];

  setSelectedSize(
    availableSizes.includes(printerSize) ? printerSize : "A4"
  );
}, [storeSettings, isPurchase, isReturn, isPreSale]);

useEffect(() => {
  if (
    !selectedOption ||
    !templateMap?.A4?.[selectedOption]
  ) {
    if (templateMap?.A4?.INVPRO) {
      setSelectedOption("INVPRO");
    } else if (templateMap?.A4?.INVOICEONE) {
      setSelectedOption("INVOICEONE");
    }
  }
}, [selectedOption, setSelectedOption]);

  useEffect(() => {
    jsPDF.API.events.push([
      "addFonts",
      function () {
        this.addFileToVFS("Inter_24pt-Regular-normal.ttf", InterRegular);
        this.addFileToVFS("Inter_24pt-Bold-normal.ttf", InterBold);
        this.addFont(
          "Inter_24pt-Regular-normal.ttf",
          "Inter-Regular",
          "normal",
        );
        this.addFont("Inter_24pt-Bold-normal.ttf", "Inter-Bold", "bold");
      },
    ]);
  }, []);

  useEffect(() => {
    jsPDF.API.events.push([
      "addFonts",
      function () {
        this.addFileToVFS(
          "NotoSansMono_24pt-Regular-normal.ttf",
          NotoSansMonoReular,
        );
        this.addFileToVFS(
          "NotoSansMono_24pt-Bold-normal.ttf",
          NotoSansMonoBold,
        );
        this.addFont(
          "NotoSansMono_24pt-Regular-normal.ttf",
          "NotoSansMono-Regular",
          "normal",
        );
        this.addFont(
          "NotoSansMono_24pt-Bold-normal.ttf",
          "NotoSansMono-Bold",
          "bold",
        );
      },
    ]);
  }, []);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === "p") {
        event.preventDefault();
        handlePrint();
      }
    };
    
    const handleAfterPrint = () => {
      setTimeout(() => {
        window.focus();
      }, 100);
    };

    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("afterprint", handleAfterPrint);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("afterprint", handleAfterPrint);
    };
  }, [data]);

  const sizeOptions =isPurchase
  ? [{ key: "A4", label: "A4" }]
  :
    isReturn || isPreSale
      ? [
          { key: "HALFA4", label: "A4 Half" },
          { key: "A4", label: "A4" },
        ]
     : [
            { key: "2INCH", label: "2 Inch" },
            { key: "3INCH", label: "3 Inch" },
            { key: "4INCH", label: "4 Inch" },
            { key: "HALFA4", label: "A4 Half" },
            { key: "A4", label: "A4" },
          ];
  const handleSelectedSale = (sale) => {
    if (sale?.saleVersion) {
      if (sale?.saleVersion === data?.saleVersion) return;
    }
    setSaleLoading(true);
    setTimeout(() => {
      setData(sale?.saleData);
      setSaleLoading(false);
    }, 300);
  };

  const handlelatestSale = (sale) => {
    setSelectedSale(sale);
  };

  const handleDownload = async (data) => {
    setDownload(true);
    try {
      const printData = isReturnView ? returnGlobalData : globalData;
      const printInvoiceConfig = isReturnView ? returnTemplateInvoiceConfig : templateInvoiceConfig;
      const salemode = printInvoiceConfig?.documentConfig?.title || "Document";
      const saleno = printInvoiceConfig?.documentConfig?.number || "Document";
      let generator;  
      let generatorType;
      if (isPreSale) {
        generatorType = showTaxDetails ? "invoice" : "bill";
      } else {
        generatorType = isBill && !isBillReceipt ? "bill" : "invoice";
      }   
      if (selectedSize === "A4") {
        const template = templateMap.A4?.[selectedOption];

        if (!template) {
          showAlert("warning", "Please select an A4 template.");
          return;
        }
        generator = template?.[generatorType] ?? template?.print;

      } else if (selectedSize === "HALFA4") {
        const template = templateMap.HALFA4?.[selectHALFA4Option];

        if (!template) {
          showAlert("warning", "Please select a Half A4 template.");
          return;
        }

        generator = template?.[generatorType] ?? template?.print;

      } else {
        const template = templateMap.TERMINAL?.[selectTermalOption];

        if (!template?.generator?.[selectedSize]) {
          showAlert("warning", "Please select a Thermal template.");
          return;
        }

        const thermalType = template.generator[selectedSize];
        generator = thermalType?.[generatorType];
      }

      if (!generator) {
        showAlert("warning", "PDF generator not found.");
        return;
      }

      // 3. Generate and save PDF
      const doc = await generator(
        printData,
        qrCodeDataUrl,
        terms,
        printInvoiceConfig,
        selectedTheme,        
        storeSettings
      );

      if (!doc) {
        showAlert("warning", "Unable to generate PDF.");
        return;
      }

      const filenamePrefix = (salemode || "TAX_INVOICE").replace(/\s+/g, "_");

      doc.save(`${filenamePrefix}_${saleno}.pdf`);
    } catch (error) {
      console.error("Download Error:", error);
      showAlert("error", "Failed to download PDF.");
    } finally {
      setDownload(false);
    }
  };

  const generateToken = async (saleId) => {  
    if (saleId === undefined) return;
    setShareLoad(true);
    try {
      const response = await AxiosInstance.post(`/module/sale/${saleId}`);

      const results = response.data.results;
      setShareLoad(false);
      return results;
    } catch (error) {
      handleError(error, showAlert);
    } finally {
      setShareLoad(false);
    }
  };

  const handleSelectedReturnSale = async (sale) => {
    setSaleLoading(true);
    try {
      if (!checkNetwork()) return;
      const response = await AxiosInstance.get(
        `module/salereturn/${sale?._id}`,
      );
      setIsReturnData(response.data.results);
      setIsReturnView(true);
      setSelectedOption("RETURN");
      setSelectHALFA4Option("RETURN");
      return response.data.results;
    } catch (error) {
      handleError(error, showAlert);
      setSaleLoading(false);
      return null;
    }finally{
        setTimeout(() => {
      setSaleLoading(false);
       }, 300);
    }    
  };

  const handleGenerateInvoice = async (data) => {
    setBtnLoading(true);
    try {
      if (!checkNetwork()) return;
      const payload = {
        saleid: data._id,
        toSaleMode: "INVOICE",
      };
      var response = await AxiosInstance.patch(
        "module/sale/convert-salemode",
        payload,
      );
      setData(response.data.results);
      if (onDataChange) {
        onDataUpdate();
      }
      showAlert("success", Messages.SUCCESS.SALE_ADDED);
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setBtnLoading(false);
      setShowConfirm(false);
    }
  };
  const handleReturnSaleReset = async () => {   
    try {
      setSaleLoading(true);
      if(data?.returnSaleData?._id){    
      handleSelectedReturnSale(data?.returnSaleData);
      }
      else{    
      const response = await handleSaleItems(data?._id);
      if (!response) return;
      const templateId = storeSettings?.invoiceSettings?.template?.templateId;
      setData(response);
      setSaleData?.(response);
      setIsReturnView(false);
      setIsReturnData(null);

      setSelectedOption(selectedTheme);
      if (templateId) {
        const a4 = templateId.match(/^([A-Z0-9]{6})/)?.[1];
        const thermal = templateId.match(/(TML[A-Z0-9]+)/)?.[1];
        const half = templateId.match(/(HA4[A-Z0-9]+)/)?.[1];

        if (a4) setSelectedOption(a4);
        if (thermal) setSelectTermalOption(thermal);
        if (half) setSelectHALFA4Option(half);
      }
      }
    } finally {
      setSaleLoading(false);
    }
  };

  const handleResetSale = () => {
    setSaleLoading(true);
    if (isReturnHistory) {
    }
    setTimeout(() => {
      setData({
        ...selectedSale?.saleData,
        projectId:
          typeof selectedSale?.saleData?.projectId === "string"
            ? isData?.projectId
            : selectedSale?.saleData?.projectId,
      });
      // setData(selectedSale?.saleData);
      setSaleLoading(false);
    }, 300);
    setCloseAuto(false);
  };

  const handleModeConfirm = () => {
    setShowConfirm(true);
  };

  const updatePrinterSetting = async (size) => {
    try {
      await AxiosInstance.patch("module/storesettings", {
        printerSettings: { paperSize: size },
      });
      updateSettings({
        storeSettings: {
          printerSettings: {
            paperSize: size,
          },
        },
      });
    } catch (error) {
      handleError(error, showAlert);
    }
  };

  const handleNormalShare = async (data, selectedOption) => {
    try {
      const shareToken = await generateToken(data?._id);

      const invoiceLink = `${uRLs.PUBLIC_PORTAL_URL}share/sale/?token=${shareToken}`;

      // Open in new tab
      window.open(invoiceLink, "_blank");
    } catch (error) {
      console.error("Error generating share link:", error);
    }
  };

  const handleWhappShare = async (data) => {
    try {
      // Create the dynamic invoice link
      const shareToken = await generateToken(data?._id);
      const invoiceLink = `${uRLs.PUBLIC_PORTAL_URL}share/sale/?token=${shareToken}`;

      // Create the message to share
      const message = `*${
        data.salefrom ? data?.salefrom?.title?.toUpperCase() : ""
      }*\nSale Receipt Sale No: *${
        data?.saleno
      }* \n\n_Click Link Below to Download :_\n${invoiceLink}\n\n---------------------\n${
        data?.saleitems && data.saleitems.length > 0
          ? data.saleitems
              .map((item, index) => {
                return `*S.No*: ${index + 1},\n*Description*: ${
                  item.title
                },\n*Qty*: ${item.quantity} ${(() => {
                  const unitCode = item?.isSecondaryUnit
                    ? item?.unitConfig?.secondaryUnitCode
                    : item?.unitConfig?.primaryUnitCode;
                  return unitCode || "";
                })()} ,${
                  item.discount > 0
                    ? `,\n*Price*: ~${item.mrp}~,\n*Discount*: ${item.discount}`
                    : ""
                },\n*Amount*: ${item.soldprice}`;
              })
              .join("\n---------------------\n")
          : "*No items found.*"
      }
          \n---------------------\n\nGrand Total : *${data?.grandtotal}*\n\n*Thank you for visiting Us*${
            storeSettings?.negobillBranding ? "\n_powered by negobill.com_" : ""
          }`;

      // Encode message for URL
      let whatsappUrl;

      if (data?.saleto?.phone) {
        const phoneNumber = data?.saleto?.phone.replace(/\D/g, "");
        whatsappUrl = `https://wa.me/${
          phoneNumber.startsWith("91") ? phoneNumber : `91${phoneNumber}`
        }?text=${encodeURIComponent(message)}`;
      } else {
        whatsappUrl = `https://wa.me/?text=${encodeURIComponent(message)}`;
      }

      window.open(whatsappUrl, "_blank");
    } catch (error) {
      console.error("Error sharing on WhatsApp:", error);
    }
  };

  const projectName =
    globalData?.projectId?.name ?? globalData?.preSaleData?.projectId?.name;
  const HalfPreview = templateMap?.HALFA4[selectHALFA4Option]?.preview;
  const A4Preview = templateMap?.A4[selectedOption]?.preview;

  if (!isOpen) return null;
// if (!selectedOption) return null;
  const returnGlobalData = isReturnView
    ? FormatedTemplateData(returnData, storeSettings)
    : null;

  const returnInvoiceConfig = isReturnView
    ? getInvoiceConfig(returnGlobalData, storeSettings, optData, settings)
    : null;
  const returnTemplateInvoiceConfig = isReturnView
  ? getTemplateInvoiceConfig(returnInvoiceConfig)
  : null;

const handleConvertToSale = (data) => {
  const preSaleId = data?.preSaleData?._id;

  if (!preSaleId) {
    console.error("Pre-Sale ID not found");
    return;
  }

  const navigatelist = "/listpresale";

  navigate("/sale", {
    state: {
      navigatelist,
      preSaleId,
      Data: data,
      convertToSale: true,
    },
  });

};
  return (
    <div className="modal-overlay" style={{ zIndex: 1010 }}>
      <div>
        <div className="modal-backdrop show"></div>

        <div
          className="modal show d-block"
          id="CustomerModal"
          tabIndex="-1"
          aria-modal="true"
          role="dialog"
        >
          <div
            className="modal-dialog modal-dialog-scrollable modal-xlg2"
            style={{
              overflowY: "auto",
              height: "calc(100vh - 200px)",
            }}
          >
            <div className="modal-content">
              <div className="modal-header">
                <div className="d-flex align-items-center">
                  <h6 className="modal-title mb-0">
                     {globalData?.purchaseItems || globalData?.purchaseNo
                      ? "PURCHASE"
                      :globalData?.returnSaleData
                      ? "RETURN SALE"
                      :globalData?.salemode
                      ? globalData.salemode
                      : globalData?.preSaleData?.preSaleMode ===
                          "PROFORMA_INVOICE"
                        ? "PROFORMA INVOICE"
                        : globalData.salemode ||
                          globalData?.preSaleData?.preSaleMode}
                  </h6>
                  <div className="d-flex align-items-center fw-bold text-dark mb-0 ">
                    {data?.status !== "CANCELLED" && data?.status !== "SUBMITTED"  &&
                      data?.saleTrack !== "RETURNED" && !documentConfig?.isPresaleConveror &&
                      (edit ? (
                        <button
                          className={`btn${isReturnHistory ? "btn-secondary" : "btn-primary"} my-2 ms-3`}
                          disabled
                        >
                          <CircularProgress size={18} className="text-black" />
                        </button>
                      ) : (
                        <button
                          className={`btn ${isReturnHistory ? "btn-secondary" : "btn-primary"} my-2 ms-3`}
                          onClick={() => handleEdit(data)}
                          disabled={isReturnHistory}
                        >
                          <EditIcon iClass="fs-15 me-2"/>
                          Edit
                        </button>
                      ))}
                     <>
                      {uRLs.RETURN_SALE === "true" && data?.status !== "CANCELLED" &&  data?.saleTrack !== "RETURNED" && !documentConfig?.isPresaleConveror &&(<>
                        <button
                          className={`btn ${isReturn ? "btn-secondary" : "btn-primary"} my-2 ms-3`}
                          onClick={(e) => {
                                    e.stopPropagation();

                                    navigate("/returnsale", {
                                      state: {
                                        saleId: globalData?.returnSaleData?.saleId || globalData?._id,
                                      },
                                    });
                                  }}
                          disabled={isReturn}
                        >
                          <UndoIcon iClass={"fs-20 me-2"}/> 
                          Return Sale
                        </button>
                        </>)}
                      </>
                  </div>
                   {isPreSale && !documentConfig?.isPresaleConveror && (
                   <button
                        className="btn btn-primary shadow-none text-right ms-3"
                        onClick={() => handleConvertToSale(globalData)}
                      >
                         <ReceiptIcon iClass=" me-2" />  Convert to Sale
                    </button> 
                  )}            
                  {viewOption("saleSettings", "isConvertToInvoice") &&
                    globalData?.salemode === "BILL" &&
                    latestVersion === globalData?.saleVersion &&
                    globalData?.status === "ACTIVE" &&
                    (isBtnLoading ? (
                      <button
                        className="btn btn-outline-secondary pb-0 text-right ms-3"
                        disabled
                      >
                        <CircularProgress size={22} className="text-white" />
                      </button>
                    ) : (
                      <button
                        className="btn btn-outline-secondary shadow-none text-right ms-3"
                        onClick={handleModeConfirm}
                      >
                         <ReceiptIcon /> To Invoice
                      </button>
                    ))}
                </div>
                {isReturnHistory ? (
                  <span className="gap-2 p-2 bg-label-info rounded-2 d-flex align-items-center">
                    <UndoIcon iClass={"font-16"}/>
                    Return Sale History -  {isReturnView
                      ? returnInvoiceConfig?.documentConfig?.number
                      : documentConfig?.number}
                    {/* -{" "} */}
                    {/* {data?.returnSaleData?.returnTrack} */}
                    <button
                      type="button"
                      onClick={handleReturnSaleReset}
                      className="btn-close custom-close-btn-returnSale"
                      style={{ marginRight: 0 }}
                      aria-label="Close"
                    ></button>
                  </span>
                ) : (
                  <>
                    {(hasModulePermission("SALE") ||
                      permission === undefined) &&
                      (blockedPermissions("SALE:history") ||
                        permission === undefined) && (
                        <div className="d-flex align-items-center">
                          {latestVersion > globalData?.saleVersion && (
                            <span className=" gap-2 p-2 bg-label-warning rounded-2 d-flex align-items-center">
                              <ShowIcon iClass={"font-16"}/>Sale History
                              - {globalData?.saleno} -{" "}
                              {getSaleTrack(globalData?.saleTrack)} - v
                              {globalData?.saleVersion}
                              <button
                                type="button"
                                onClick={handleResetSale}
                                className="btn-close custom-close-btn-v2"
                                style={{ marginRight: "0px" }}
                                data-bs-dismiss="modal"
                                aria-label="Close"
                              ></button>
                            </span>
                          )}
                        </div>
                      )}
                  </>
                )}
                <div className="d-flex align-items-center gap-1">
                  {projectName && (
                    <>
                      <p className="d-flex align-items-center justify-content-between  badge rounded-pill bg-label-project cursor-poInter mb-0">
                        <span class="me-2">
                          <i class="bi bi-hammer fs-6"></i>
                        </span>
                        {capitalizeFirstLetter(projectName) || "-"}
                      </p>
                      <span className="mx-2 text-muted">|</span>
                    </>
                  )}
                  <p className="small mb-0 ">
                    <b className="tm_primary_color"> Created On:</b>{" "}
                    {createdTime.date} {""}
                    {createdTime.time}
                  </p>
                  <button
                    type="button"
                    onClick={handleClose}
                    className="btn-close border ms-1"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>
              </div>
              <div className="modal-body d-flex p-0" id="element-to-download">
                <InvoiceToggleActionCard
                  optData={optData}
                  returnTrack={isReturnHistory}
                  setOptData={setOptData}
                  setBilling={setBilling}
                  setSelectTermalOption={setSelectTermalOption}
                  setSelectHALFA4Option={setSelectHALFA4Option}
                  isPreSale={isPreSale}
                  isPurchase={isPurchase}
                />
                {saleLoading ? (
                  <div
                    className="d-flex justify-content-center"
                    style={{
                      overflowY: "auto",
                      maxHeight: "100%",
                      width: "100%",
                      paddingRight: "12px",
                      paddingLeft: "12px",
                    }}
                  >
                    <CircularProgress size={20} className="text-primary" />
                  </div>
                ) : (
                  <div
                    className="pt-2"
                    style={{
                      overflowY: "auto",
                      maxHeight: "100%",
                      width: "100%",
                      paddingRight: "12px",
                      paddingLeft: "12px",
                    }}
                  >
                    {" "}
                    {isReturnView ? (
                      <ReturnSaleInvoice
                        globalData={returnGlobalData}
                        terms={terms}
                        qrCodeDataUrl={qrCodeDataUrl}                        
                        selectedTheme={selectedTheme}
                        invoiceConfig={returnTemplateInvoiceConfig}
                      />
                    ) :
                     isPurchase ? (<>
                      <PurchaseView
                        data={globalData}                       
                        selectedTheme={selectedTheme}                                            
                        invoiceConfig={templateInvoiceConfig}
                      />
                      </>
                    ) 
                    : selectedSize === "HALFA4" && HalfPreview ? (
                      <HalfPreview
                        data={globalData}   
                        qrCodeDataUrl={qrCodeDataUrl}                     
                        selectedTheme={selectedTheme}
                        optData={optData}
                        invoiceConfig={templateInvoiceConfig}
                      />
                    ) : (
                      <>
                        <A4Preview
                          globalData={globalData}
                          terms={terms}
                          qrCodeDataUrl={qrCodeDataUrl}
                          selectedTheme={selectedTheme}
                          invoiceConfig={templateInvoiceConfig} //templateInvoiceConfig
                        />
                      </>
                    )}
                  </div>
                )}
                <InvoiceInfoSidebar
                  globalData={globalData}
                  optData={optData}
                  returnTrackId={documentConfig?.saleId}
                  returnTrack={isReturnHistory}
                  handleSelectedSale={handleSelectedSale}
                  handlelatestSale={handlelatestSale}
                  latestVersion={latestVersion}
                  closeAuto={closeAuto}
                  setData={setData}
                  setCloseAuto={setCloseAuto}
                  isData={data}
                  invoiceConfig={isReturnView ? returnInvoiceConfig : invoiceConfig}
                  handleSelectedReturnSale={handleSelectedReturnSale}                  
                  isPurchase={isPurchase}
                />
              </div>
              {showConfirm && (
                <Convertinvoice
                  onClose={() => setShowConfirm(false)}
                  onConfirm={() => handleGenerateInvoice(data)}
                />
              )}
              <PaySettleModal
                isOpen={isPaySettleModalOpen}
                data={data}
                setIsPaySettleModalOpen={setIsPaySettleModalOpen}
                setIsMainModalOpen={setIsMainModalOpen}
                isBtnLoading={isBtnLoading}
                setBtnLoading={setBtnLoading}
              />
              <div className="modal-footer d-flex justify-content-between">
                <button
                  onClick={handleClose}
                  type="button"
                  data-bs-dismiss="modal"
                  className="btn btn-outline-secondary text-left"
                >
                  <XIcon iClass={"fs-15"}/> Close
                </button>
                <div className="my-2 d-flex gap-2">
                  {share ? (
                    <button
                      className="btn btn-success  pb-0 text-right"
                      disabled
                    >
                      <CircularProgress size={18} className="text-black" />
                    </button>
                  ) : (
                    <button
                      className={`btn ${isReturn ? "btn-secondary" : "btn-primary"}  text-right`}
                      disabled={isReturn}
                      onClick={() => handleNormalShare(data, selectedOption)}
                    >
                      <ShareIcon iClass="fs-20"/>
                    </button>
                  )}
                  {/* {data.status !== "CANCELLED" &&
                                        (edit ? (
                                          <button className="btn btn-warning pb-0 text-right" disabled>
                                            <CircularProgress size={18} className="text-black" />
                                          </button>
                                        ) : (
                                          <button
                                            className={`btn ${isReturn ? "btn-secondary" : "btn-primary"} pb-0 text-right`}
                                            onClick={() => handleEdit(data)}
                                            disabled={isReturn ||data.saleTrack ==="RETURNED"}
                                          >
                                            <i className="ng ng-ng-edit-icon fs-15"></i>
                                          </button>
                                        ))} */}

                  {shareLoad ? (
                    <button
                      className="btn btn-success  pb-0 text-right"
                      disabled
                    >
                      <CircularProgress size={18} className="text-black" />
                    </button>
                  ) : (
                    <button
                      className={`btn ${isReturn ? "btn-secondary" : "btn-success"}  text-right`}
                      id="generatebillpdfbtn"
                      disabled={isReturn}
                      onClick={() => handleWhappShare(globalData)}
                    >
                      <WhatsappIcon iClass={"fs-20"}/>
                    </button>
                  )}
                  {download ? (
                    <button
                      className="btn btn-warning  pb-0 text-right"
                      disabled
                    >
                      <CircularProgress size={18} className="text-black" />
                    </button>
                  ) : (
                    <button
                      className="btn btn-warning  text-right"
                      id="generatebillpdfbtn"
                      onClick={() => handleDownload(globalData)}
                    >
                      <DownloadIcon iClass="fs-15"/>
                    </button>
                  )}

                  <div className="btn-group text-right align-items-center">
                    {print ? (
                      <button className="btn btn-warning  pb-0" disabled>
                        <CircularProgress size={18} className="text-black" />
                      </button>
                    ) : (
                      <>
                        {/* Dropdown toggle */}
                        <button
                          type="button" // ✅ FIXED
                          className="btn bg-label-animal shadow-none  dropdown-toggle dropdown-toggle-split"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                          style={{ borderRight: "2px solid #fff" }}
                        />

                        <button
                          onClick={handlePrint}
                          className="btn bg-label-animal shadow-none  rounded-end"
                          id="printreceiptbtn"
                        >
                          <PrinterIcon iClass={"fs-15"}/> Print{" "}
                          {selectedSize}
                        </button>

                        {/* Dropdown menu */}
                        <ul className="dropdown-menu dropdown-menu-end">
                          {sizeOptions.map((opt) => (
                            <li key={opt.key}>
                              <button
                                className={`dropdown-item ${
                                  selectedSize === opt.key ? "active" : ""
                                }`}
                                onClick={() => {
                                  setSelectedSize(opt.key);
                                   if (permission === undefined) {
                                  updatePrinterSetting(opt.key); // 🔥 PATCH API
                                    }
                                }}
                              >
                                {opt.label}
                              </button>
                            </li>
                          ))}
                        </ul>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TemplateModalLayout;
